/**
 * Copia um texto para o clipboard
 * @param text - Texto a ser copiado
 * @returns Promise<boolean> - true se copiado com sucesso, false caso contrário
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error("Erro ao copiar para o clipboard:", err);
    return false;
  }
};

